import { useIsMounted } from "@common/hooks";
import { isUndefined } from "lodash";
import { observer } from "mobx-react";
import React, { useCallback, useState } from "react";
import { PaginationComponentProps } from "react-data-table-component";
import ReactPaginate from "react-paginate";

export interface IUnknownPageCountPaginationProps extends PaginationComponentProps {
    hasMore?: boolean;
}

export const UnknownPageCountPagination = observer(({ rowsPerPage, onChangePage, onChangeRowsPerPage, currentPage, hasMore = true, ...props }: IUnknownPageCountPaginationProps) => {
    const isMounted = useIsMounted();     

    const handleRowsPerPage = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            onChangeRowsPerPage(Number(e.target.value), currentPage);
            onChangePage(1, props.rowCount);                                           
        }, [currentPage, onChangeRowsPerPage, onChangePage, props.rowCount]);

	// TODO: maybe allow this to be set from RemoteDataTable.tsx in the future?
    const [defaultRowsPerPageOptions] = useState([10, 25, 50, 100]);

    const handlePageChange = useCallback((pageNumber: number) => {
        if (!isUndefined(pageNumber) && isMounted()) {
            onChangePage(pageNumber + 1, props.rowCount);            
        }
    }, [onChangePage, isMounted, props.rowCount]);    

    return (
        <nav className="pagination mt-3 px-1 d-flex justify-content-end align-items-center" data-testid="datapager">            
                <span className="me-2">Rows per page:</span>
                <select className="form-select form-select-sm me-3" style={{ width: '80px' }} onChange={handleRowsPerPage} defaultValue={rowsPerPage} data-testid="rowsPerPage">
                    {
                        defaultRowsPerPageOptions.map((num: number) => (
                            <option key={num} value={num} data-testid="rpp-option">
                                {num}
                            </option>
                        ))
                    }
                </select>
            <ReactPaginate                            
                pageCount={hasMore ? currentPage + 1 : currentPage}
                onPageChange={(args) => {
                    handlePageChange(args.selected)
                }}
                forcePage={currentPage - 1}
                pageRangeDisplayed={1}                                         
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                containerClassName={'pagination justify-content-end mb-0'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextClassName={'page-item'}
                nextLinkClassName={'page-link'}
                activeClassName={'active'}          
            />
        </nav>
    );
});
